import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
  Checkbox,
} from "@material-ui/core";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { GetTemporaryAgencyFeeWeeklyExportUrl } from "../service/temporary-access-service";
interface IProps {
  data: any;
  isSelected: boolean;
  onCheckboxChange: (data, value) => void;
}
export const WeeklySummaryItem = ({ data, onCheckboxChange, isSelected }: IProps) => {
  const classes = useStyles();

  const openPdf = async () => {
    GetTemporaryAgencyFeeWeeklyExportUrl(data.Id, (result) => {
      var win = window.open(result, "_blank");
      win?.focus();
    });
  };

  return (
    <Box data-order="order-item" className={classes.container}>
      <Container className={classes.root}>
        <div className={classes.checkbox}>
          <Checkbox
            checked={isSelected}
            value="remember"
            color="primary"
            onChange={(e: any) => onCheckboxChange(data, e.target.checked)}
          />
        </div>
        <Grid
          item
          container
          xs={12}
          justifyContent="flex-start"
          onClick={openPdf}>
          <Grid item>
            <Typography variant="h6" component="span" color="textPrimary">
              {data.FileName}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles(() => ({
  container: {
    marginBottom: "24px",
  },
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 24px",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    cursor: "pointer",
    transition: "all 200ms ease",
    ...textButtonHoverAndActive
  },
  gridMargin: {
    marginTop: "5px",
  },
  checkbox: {
    paddingRight: 24,
  },
}));
